module.exports = __webpack_public_path__ + "img/degen.25748969.png";